module.exports = __webpack_public_path__ + "static/media/bancolombia-ico-eliminar-hv.25090ea8.svg";